// MS-4 — "Come funziona": editorial 3-step block.
// Purely presentational. No new capability, no backend.
import { ChevronRight } from "lucide-react";

const steps = [
  {
    title: "Racconta",
    text: "Manda un vocale, una foto o un messaggio su WhatsApp mentre sei al lavoro.",
  },
  {
    title: "Mastro mette in ordine",
    text: "Organizza clienti, lavori, foto e aggiornamenti, così ogni informazione resta collegata al lavoro giusto.",
  },
  {
    title: "Ritrova",
    text: "Quando ti serve, ritrovi cosa hai fatto, cosa hai aggiunto e cosa avevi concordato, senza cercare tra chat, foto e appunti.",
  },
];

export const HowItWorks = () => (
  <div data-testid="landing-how-it-works">
    <p className="text-sm font-bold uppercase tracking-[0.2em] text-teal-600 sm:text-base">
      Come funziona
    </p>
    <h2 className="mt-3 max-w-xl text-2xl font-extrabold tracking-tight text-neutral-950 sm:text-3xl">
      Ovunque tu sia, in qualsiasi momento.
    </h2>

    <ol className="mt-14 grid grid-cols-1 gap-12 sm:grid-cols-3 sm:gap-8 lg:gap-12">
      {steps.map(({ title, text }, i) => (
        <li
          key={title}
          data-testid={`landing-step-${i + 1}`}
          className="relative"
        >
          <span className="block text-4xl font-black leading-none tracking-tight text-neutral-950 sm:text-5xl">
            0{i + 1}
          </span>
          <span
            aria-hidden="true"
            className="mt-4 block h-[3px] w-10 bg-teal-500"
          />
          <h3 className="mt-5 text-lg font-extrabold tracking-tight text-neutral-950 sm:text-xl">
            {title}
          </h3>
          <p className="mt-2.5 max-w-sm text-sm leading-relaxed text-neutral-600 md:text-base">
            {text}
          </p>

          {i < steps.length - 1 && (
            <ChevronRight
              aria-hidden="true"
              className="absolute -right-2 top-1 hidden h-5 w-5 text-neutral-300 sm:block lg:-right-5"
            />
          )}
        </li>
      ))}
    </ol>
  </div>
);
